<button mat-button [matMenuTriggerFor]="menu" aria-label="User actions menu">
  <mat-icon class="material-symbols-outlined">account_circle</mat-icon>
  {{ (user | async)?.login }}
</button>

<mat-menu #menu="matMenu">
  <ng-template matMenuContent>
    <button mat-menu-item (click)="logout()">
      <mat-icon class="material-symbols-outlined">logout</mat-icon>
      <span>Logout</span>
    </button>
  </ng-template>
</mat-menu>
